import React, { useState } from "react";
import { Icons } from "./icons.jsx";
import { Pill } from "./primitives.jsx";
import {
  AccordionRoot,
  AccordionItem,
  AccordionHeader,
  AccordionIconBox,
  AccordionTitleFlex,
  AccordionTitle,
  AccordionSubPills,
  AccordionBody,
  AccordionDesc,
  AccordionSessionList,
  AccordionSessionRow,
  AccordionSessionIcon,
  AccordionSessionTitle,
  AccordionPillsRow,
} from "./style.js";

// ── TopicAccordion ────────────────────────────────────────────────────────────
const TopicAccordion = ({ topics }) => {
  const [open, setOpen] = useState(null);

  return (
    <AccordionRoot>
      {topics.map((t, i) => {
        const isOpen = open === i;
        const sessions = t.scenarios ?? [];
        const skillCount = sessions.filter((s) => !s.has_scoring_engine).length;
        const simCount = sessions.filter((s) => s.has_scoring_engine).length;
        return (
          <AccordionItem key={t.name}>
            {/* ── Accordion header ── */}
            <AccordionHeader onClick={() => setOpen(isOpen ? null : i)}>
              <AccordionIconBox $isOpen={isOpen}>
                <Icons.topic
                  size={16}
                  style={{ color: isOpen ? "#01ECFF" : "#A87EFF" }}
                />
              </AccordionIconBox>
              <AccordionTitleFlex>
                <AccordionTitle $isOpen={isOpen}>{t.name}</AccordionTitle>
                <AccordionSubPills>
                  {skillCount > 0 && (
                    <Pill tone="turq" size="sm">
                      <Icons.book size={10} /> {skillCount} Skill Dev Session
                      {skillCount !== 1 ? "s" : ""}
                    </Pill>
                  )}
                  {simCount > 0 && (
                    <Pill tone="tag" size="sm">
                      <Icons.users size={10} /> {simCount} Simulation
                      Challenge{simCount !== 1 ? "s" : ""}
                    </Pill>
                  )}
                </AccordionSubPills>
              </AccordionTitleFlex>
              <Icons.chevDown
                size={16}
                style={{
                  color: "#A87EFF",
                  transform: isOpen ? "rotate(180deg)" : "none",
                  transition: "transform 200ms",
                  flexShrink: 0,
                }}
              />
            </AccordionHeader>

            {/* ── Expanded content ── */}
            {isOpen && (
              <AccordionBody>
                {t.description && <AccordionDesc>{t.description}</AccordionDesc>}

                {/* Session list */}
                <AccordionSessionList>
                  {sessions.map((s, si) => {
                    const isSim = s.has_scoring_engine;
                    return (
                      <AccordionSessionRow key={si} $isSim={isSim}>
                        {/* type icon */}
                        <AccordionSessionIcon $isSim={isSim}>
                          {isSim ? (
                            <Icons.users
                              size={13}
                              style={{ color: "#A87EFF" }}
                            />
                          ) : (
                            <Icons.book
                              size={13}
                              style={{ color: "#01ECFF" }}
                            />
                          )}
                        </AccordionSessionIcon>

                        {/* title */}
                        <AccordionSessionTitle>{s.name}</AccordionSessionTitle>
                      </AccordionSessionRow>
                    );
                  })}
                </AccordionSessionList>

              </AccordionBody>
            )}
          </AccordionItem>
        );
      })}
    </AccordionRoot>
  );
};

export default TopicAccordion;
